import React, { useRef, useEffect } from 'react';
import './HeroSection.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const HeroSection = () => {
  const videoRef = useRef(null);
  
  // Handle video loading and play
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      // Try to play the video automatically
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("Video autoplay prevented:", error);
          // Show fallback play button for browsers that block autoplay
          const playButton = document.getElementById('video-play-fallback');
          if (playButton) {
            playButton.style.display = 'block';
          }
        });
      }
    }
  }, []);

  const handlePlayVideo = () => {
    const video = videoRef.current;
    if (video) {
      video.play();
      const playButton = document.getElementById('video-play-fallback');
      if (playButton) {
        playButton.style.display = 'none';
      }
    }
  };

  // Function to scroll to Form section
  const scrollToForm = () => {
    const formSection = document.getElementById('form-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Handle Contact button clicks
  const handleContactClick = () => {
    scrollToForm();
  };

  return (
    <section className="hero-section">
      {/* Background Video */}
      <div className="video-container">
        <video
          ref={videoRef}
          className="background-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src="/hero.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Video overlay for better text readability */}
        <div className="video-overlay"></div>
        
        {/* Fallback play button for browsers that block autoplay */}
        <button 
          id="video-play-fallback" 
          className="video-play-fallback"
          onClick={handlePlayVideo}
        >
          ▶ Play Background Video
        </button>
      </div>

      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="nav-container">
          {/* Logo */}
          <div className="logo-container">
            <img src="./logo.png" alt="EZ Raider Logo" className="logo-img" />
          </div>
          
          {/* Contact Button */}
          <button className="contact-btn" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="headline-container">
          <h1 className="headline">
            <span className="headline-line first-line">RIDE WITH POWER</span>
            <span className="headline-line second-line">EXPERIENCE FREEDOM</span>
          </h1>
          
          <p className="hero-subtitle">
            Electric off road mobility designed for stability, control, and real world performance. EZ Raider vehicles deliver intuitive handling, low maintenance operation, and dependable capability across varied terrain.
          </p>
          
          {/* Call-to-Action Buttons */}
          <div className="cta-buttons">
            <button className="cta-btn contact-main-btn" onClick={handleContactClick}>
              CONTACT
              <ArrowForwardIcon className="btn-icon" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;